export default [
  {
    path: '/b/perkin',
    redirect: '/b/perkin',
    name: 'bPerkin',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'bPerkinIndex',
        component: () => import('@/views/b/perkin/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'b-perkin',
          pageTitle: 'Perkin',
          breadcrumb: [
            {
              text: 'Perkin',
              active: true,
            },
          ],
        },
      },
      // {
      //   path: '/perkin/input',
      //   name: 'perkinInput',
      //   component: () => import('@/views/perkin/Tambah.vue'),
      //   meta: {
      //     action: 'Buat',
      //     resource: 'perkin',
      //     pageTitle: 'Input Perkin',
      //     breadcrumb: [
      //       {
      //         text: 'Perkin',
      //       },
      //       {
      //         text: 'Input',
      //         active: true,
      //       },
      //     ],
      //   },
      // },
    ],
  },
]
